function copyTextToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text);
  }

  return new Promise((resolve, reject) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      const copied = document.execCommand('copy');
      document.body.removeChild(textarea);
      copied ? resolve() : reject(new Error('Copy command failed'));
    } catch (error) {
      document.body.removeChild(textarea);
      reject(error);
    }
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-copy-pnld-code]');
  if (!button) return;

  const container = button.closest('.product-pnld__actions, [id^="ProductPnldActions-"]');
  const code = container?.querySelector('[data-pnld-code]')?.textContent?.trim();
  if (!code) return;

  event.preventDefault();

  const defaultLabel = button.querySelector('.button__text')?.textContent.trim() || button.textContent.trim();
  const successLabel = button.dataset.copySuccess || defaultLabel;
  const textElement = button.querySelector('.button__text');

  copyTextToClipboard(code)
    .then(() => {
      if (textElement) {
        textElement.textContent = successLabel;
      } else {
        button.textContent = successLabel;
      }

      window.setTimeout(() => {
        if (textElement) {
          textElement.textContent = defaultLabel;
        } else {
          button.textContent = defaultLabel;
        }
      }, 2000);
    })
    .catch((error) => {
      console.error(error);
    });
});
